/**
 * OAuth のうち、API と画面の**両方**が知っている必要がある値。
 *
 * 同意画面は SPA の経路なのに、その URL を `authorization_endpoint` として
 * 名乗るのは Worker (`/.well-known/oauth-authorization-server`)。片方だけ
 * 変えると、クライアントは存在しない画面へ利用者を送り、しかも
 * SPA の wildcard がホームへ攫うので**成功したように見える**。
 * だからここ 1 箇所に置く。
 */

/** 同意画面 (`authorization_endpoint`)。SPA のルート。 */
export const OAUTH_CONSENT_PATH = '/oauth/consent';

/** 発行できるスコープ。MCP の 1 つだけ。 */
export const OAUTH_SCOPE = 'mcp';
